import { BaseCameraPointersInput, Nullable, PointerTouch, serialize } from '@babylonjs/core';
import { Flat2DCamera } from 'Framework/Components/Controls/XView/Cameras';

export class ZoomAndPanPointersInput extends BaseCameraPointersInput {
    /**
      * Called on pointer POINTERMOVE event if only a single touch is active.
      * Override this method to provide functionality.
      */
    public onTouch(point: Nullable<PointerTouch>,
        offsetX: number,
        offsetY: number): void {
        if (this.camera.getScene().useRightHandedSystem) {
            offsetX *= -1;
        }

        if (this.camera.parent?._getWorldMatrixDeterminant() < 0) {
            offsetX *= -1;
        }

        let speed = this.camera.fov / this.sensibility;

        this.camera.position.x += speed * -offsetX;
        this.camera.position.y += speed * offsetY;
    }

    /**
     * Called on pointer POINTERMOVE event if multiple touches are active.
     * Override this method to provide functionality.
     */
    public onMultiTouch(
        pointA: Nullable<PointerTouch>,
        pointB: Nullable<PointerTouch>,
        previousPinchSquaredDistance: number,
        pinchSquaredDistance: number,
        _previousMultiTouchPanPosition: Nullable<PointerTouch>,
        _multiTouchPanPosition: Nullable<PointerTouch>
    ): void {
        if (pointA && pointB) {
            if (previousPinchSquaredDistance == 0 || pinchSquaredDistance == 0) {
                return;
            }

            this.camera.inertialRadiusOffset += (pinchSquaredDistance - previousPinchSquaredDistance) / this.pinchSensibility;
        }
    }

    public camera: Flat2DCamera;

    /**
    * Defines the pointer angular sensibility  along the X and Y axis or how fast is the camera rotating.
    */
    @serialize()
    public sensibility = 1200.0;

    @serialize()
    public pinchSensibility = 10.0;
}